// extracted by mini-css-extract-plugin
export default {"link":"FileLink_link__chLhH","downloading":"FileLink_downloading__X6bYy"};